import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JwtService from '../common/jwt.service'
import { API_URL } from '../common/config'

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = API_URL
  },
  setHeader () {
    Vue.axios.defaults.headers.common['Authorization'] = `Token ${JwtService.getToken()}`
  },
  setFileHeader () {
    Vue.axios.defaults.headers.common['Authorization'] = `Token ${JwtService.getToken()}`
    Vue.axios.defaults.headers.post['Content-Type'] = false
    Vue.axios.defaults.headers.post['enctype'] = 'multipart/form-data'
    delete Vue.axios.defaults.headers.common['Accept']
    // console.log(Vue.axios.defaults.headers)
  },
  query (resource, params) {
    let parms = params + '&nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.get(resource, parms).catch(error => {
      throw new Error(`ApiService ${error}`)
    })
  },
  get (resource, slug = '') {
    let parms = slug
    if (slug.includes('?') || resource.includes('?')) {
      if (slug === '') {
        resource = resource + '&nocache=' + new Date().getTime() // Safari fix
      } else {
        parms = slug + '&nocache=' + new Date().getTime() // Safari fix
      }
    } else {
      if (slug === '') {
        parms = '?nocache=' + new Date().getTime() // Safari fix
      } else {
        parms = slug + '/?nocache=' + new Date().getTime() // Safari fix
      }
    }
    return Vue.axios.get(`${resource}/${parms}`)
  },
  post (resource, params) {
    console.log(Vue.axios)
    let parms = resource + '?nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.post(`${parms}`, params)
  },
  update (resource, slug, params) {
    let parms = slug + '/?nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.put(`${resource}/${parms}/`, params).catch(error => {
      throw new Error(`ApiService ${error}`)
    })
  },
  put (resource, params) {
    let parms = resource + '?nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.put(`${parms}`, params)
  },
  patch (resource, params) {
    let parms = resource + '?nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.patch(`${parms}`, params)
  },
  delete (resource) {
    let parms = resource + '?nocache=' + new Date().getTime() // Safari fix
    return Vue.axios.delete(parms)
  }
}

export default ApiService
